import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'
import { Game } from '../../../Core'

import * as actions from '../ranking.actions'
import * as selectors from '../ranking.selectors'

/**
 *  Pop up showed when you have finished the game
 */
class ChatPopup extends React.Component {
  /**
   *  Component constructor.
   */
  constructor(props) {
    super(props)
    this.submit = this.submit.bind(this)
    this.state = {
      growInClass: 'growIn-animation',
    }
  }

  closePopup() {
    const { removePopup } = this.props
    this.setState({ growInClass: '' })
    setTimeout(() => {
      removePopup('chat_popup')
    }, 1000)
  }

  submit(e) {
    const { target } = this.props

    e.preventDefault()
    e.stopPropagation()
    const { sendMessage } = this.props
    const payload = { message: this.form['message'].value, target }
    sendMessage(payload)
    this.closePopup()
  }

  render() {
    const { growInClass } = this.state

    return (
      <div className={`layer--mis__box--message position--absolute z-index2`}>
        <div className={`mis--box__message ${growInClass ? growInClass : ''}`}>
          <form onSubmit={this.submit} ref={(form) => (this.form = form)}>
            <div className="mis--box__message--head">
              <span>
                <FormattedMessage id="chat.writeMessagePlaceholder" />
              </span>
              <span className="icon-cross" onClick={() => this.closePopup()}>
                {' '}
              </span>
            </div>
            <textarea name="message" id="message" cols="" rows="5"></textarea>

            <div className="mis--box__message--footer">
              <div className="btn--orange" onClick={this.submit}>
                <span>
                  <FormattedMessage id={'chat.submit'} />
                </span>
              </div>
            </div>
          </form>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    sendMessage: bindActionCreators(actions.sendMessage, dispatch),
    removePopup: bindActionCreators(Game.actions.removePopup, dispatch),
  }
}

const mapStateToProps = (state) => {
  return {
    target: selectors.getChatTarget(state),
  }
}

ChatPopup.propTypes = {
  sendMessage: PropTypes.func,
  target: PropTypes.object,
  removePopup: PropTypes.func,
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(ChatPopup))
